import {Container} from "@pg-design/grid-module";
import {backgroundColor} from "@pg-design/helpers-css";
import {HomeIcon} from "@pg-design/icons-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../../app/components/breadcrumbs/Breadcrumbs";
import {IBreadcrumb} from "../../../app/components/breadcrumbs/IBreadcrumb";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {getWhichLabelFromPricesViewType, PricesViewType} from "../helpers/prices_view_type";

interface IProps {
    type: PricesViewType;
    region?: IRegionReportPrice | null;
}
export const PricesBreadcrumbs = (props: IProps) => {
    const items: IBreadcrumb[] = [
        {name: `Ceny ${getWhichLabelFromPricesViewType(props.type)}`, url: rpAppLink.prices.flats.base()},
        ...(props.region ? [{name: props.region.short_name, url: rpAppLink.prices.flats.city({regionSlug: props.region.slug})}] : [])
    ];

    return (
        <div css={backgroundColor("#fff")}>
            <Container>
                <Breadcrumbs homePageUrl={rpAppLink.base()} homePageIcon={<HomeIcon size="1.4" />} items={items} />
            </Container>
        </div>
    );
};
import {Container} from "@pg-design/grid-module";
import {backgroundColor} from "@pg-design/helpers-css";
import {HomeIcon} from "@pg-design/icons-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../../app/components/breadcrumbs/Breadcrumbs";
import {IBreadcrumb} from "../../../app/components/breadcrumbs/IBreadcrumb";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {getWhichLabelFromPricesViewType, PricesViewType} from "../helpers/prices_view_type";

interface IProps {
    type: PricesViewType;
    region?: IRegionReportPrice | null;
}
export const PricesBreadcrumbs = (props: IProps) => {
    const items: IBreadcrumb[] = [
        {name: `Ceny ${getWhichLabelFromPricesViewType(props.type)}`, url: rpAppLink.prices.flats.base()},
        ...(props.region ? [{name: props.region.short_name, url: rpAppLink.prices.flats.city({regionSlug: props.region.slug})}] : [])
    ];

    return (
        <div css={backgroundColor("#fff")}>
            <Container>
                <Breadcrumbs homePageUrl={rpAppLink.base()} homePageIcon={<HomeIcon size="1.4" />} items={items} />
            </Container>
        </div>
    );
};
